import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask4700To4799Service {

  constructor() { }
}
